import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IFacebookPostDetailsPutDto } from '../Models/IFacebookPostDetailsPutDto';
import { FacebookPostsPaginationResponse, IGetFacebookPostsData } from '../Models/IFacebookPost';
import { IFacebookComment } from '../Models/IFacebookComment';
import { environment } from '../../../../environments/environment';
import { IApiResponseDto, IFilterBody, IPagination, IPolitician, IPostType, ITopic } from '../../../helpers/general.interface';
import { HelperFunctions } from '../../../helpers/HelperFunctions';
import { map } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class FacebookService {
  constructor(private http: HttpClient) {}

  public getAllPosts(pagination: IPagination, sortBy: string, sortDir: string, searchVal: string, filters: IFilterBody[]): Observable<FacebookPostsPaginationResponse> {
    let params: HttpParams = new HttpParams();
    

    if (pagination) {
      params = HelperFunctions.addPaginationToParams(params, pagination);
    }
    
    if (sortBy)
      params = params.set('sortBy', sortBy);

    
    if (sortDir)
      params = params.set('sortDir', sortDir);
    
    if (searchVal)
      params = params.set('searchVal', searchVal);
    
    return this.http.post<FacebookPostsPaginationResponse>(
      `${environment.facebookUrl}/Facebook/list`,
      filters || [],
      { params: params }
    );
  }


   public updatePostDetails(body: IFacebookPostDetailsPutDto): Observable<IApiResponseDto> {
    let response: Observable<IApiResponseDto> = this.http.put<IApiResponseDto>(`${environment.facebookUrl}/Facebook`, body)
    return response
   }


   public getPostDetails(id: number): Observable<IGetFacebookPostsData> {
    return this.http.get<IGetFacebookPostsData>(`${environment.facebookUrl}/Facebook/${id}`);
  }

   public getPostComments(id: number): Observable<IFacebookComment[]> {

    let response: Observable<IFacebookComment[]> = this.http.get<IFacebookComment[]>(`${environment.facebookUrl}/Facebook/${id}/comments`)
    return response
   }


   public getCommentDetails(id: string): Observable<IFacebookComment> {

    let response: Observable<IFacebookComment> = this.http.get<IFacebookComment>(`${environment.facebookUrl}/Comment/${id}`)
    return response
   }


   public getPoliticianDetails(politicianId: string): Observable<IPolitician> {
    let response = this.http.get<IPolitician>(`${environment.facebookUrl}/Politician/${politicianId}`);
    return response;
   }
  

   public getPoliticians(): Observable<IPolitician[]> {
    let response = this.http.get<IPolitician[]>(`${environment.facebookUrl}/Politician/list`);
    return response;
   }
  

   public getAttackedPoliticians(): Observable<IPolitician[]> {
     return this.http.get<IPolitician[]>(`${environment.facebookUrl}/Politician/attacked-politicians`)
       .pipe(
          map(response => response.map(item => ({
            name: item.name,
            id: item.name
        } as IPolitician))));
   }

   public getPostTypes(): Observable<IPostType[]> {

    let response: Observable<IPostType[]> = this.http.get<IPostType[]>(`${environment.facebookUrl}/Facebook/post-types`)
    return response
   }


   public getPostTopics(): Observable<ITopic[]> {

    let response: Observable<ITopic[]> = this.http.get<ITopic[]>(`${environment.facebookUrl}/Facebook/topics`)
    return response
   }
}